import { QESCheckbox } from "@app/shared/qes-standards/forms/Checkbox";
import cx from "classnames";
import { JSX } from "react";

interface RoundCheckboxProps {
  /**
   *  The label to show above the range
   */
  label: string | JSX.Element;
  /**
   *  The values array that is used in the array.map function.
   *  Typically this would be a sequence of numbers, such as [1,2,3,4,5]
   */
  values: number[];
  /**
   *  Used for the QA automated test handle, and as the element's unique id
   */
  testId: string;
  /**
   * A boolean value indicating whether or not to include the "Unknown" option.
   * Not that this prop will result in the value of null being passed to the
   * isChecked and onChange methods.
   */
  includesUnknown?: boolean;
  /**
   * A boolean value indicating whether or not the checkbox is checked.
   */
  isChecked: (value: number) => boolean;
  /**
   *  A method to set the currently selected range
   */
  onChange: (value: number) => void;
  /**
   * Optional label override for the "Unknown" option added by includesUnknown. Defaults to "Unknown".
   */
  unknownLabel?: string;
}

/**
 * A custom component to display round checkboxes for each value passed in the values array.
 * This is typically utilized for a score range as used in Provider Hub Advanced Filters.
 */
const RoundCheckbox: React.FC<RoundCheckboxProps> = ({ label, values, testId, includesUnknown, isChecked, onChange, unknownLabel }) => {
  return (
    <>
      <span className="round-checkbox-label">{label}</span>
      <div className="round-checkbox-row">
        {includesUnknown && (
          <span className={cx("round-checkbox string-value")} key={`${testId}-label-Unknown`}>
            <QESCheckbox
              checked={isChecked(null)}
              key={`${testId}-Unknown`}
              label={unknownLabel || "Unknown"}
              onChange={() => onChange(null)}
              testId={`${testId}-Unknown`}
            />
          </span>
        )}
        {values.map((value) => (
          <span className={cx("round-checkbox number-value")} key={`${testId}-label-${value}`}>
            <QESCheckbox
              checked={isChecked(value)}
              key={`${testId}-${value}`}
              label={value.toString()}
              onChange={() => onChange(value)}
              testId={`${testId}-${value}`}
            />
            {/* <span className={cx("round-checkbox-text number-value", { "checked": isChecked(value) })} key={`${testId}-text-${value}`}>
              {value}
            </span> */}
          </span>
        ))}
      </div>
    </>
  );
};

export default RoundCheckbox